import { Component, Input, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/services/modal.service';
import { Device } from '@app/store/device.model';

@Component({
  selector: 'app-quick-open-button',
  templateUrl: './quick-open-button.component.html',
  imports: [NgbTooltip],
})
export class QuickOpenButtonComponent {
  private modalService = inject(ModalService);

  @Input() device: Device;

  onQuickOpen() {
    this.modalService.openQuickOpenModal(this.device);
  }
}
